import { Component, Input, Output, EventEmitter, ContentChild, Directive } from '@angular/core';

export type AccordionVariant = 'default' | 'bordered' | 'flush';

@Directive({ selector: '[accordionHeader]' })
export class AccordionHeaderDirective {}

@Component({
  selector: 'app-accordion-panel',
  templateUrl: './accordion-panel.component.html',
  styleUrls: ['./accordion-panel.component.scss']
})
export class AccordionPanelComponent {
  @Input() title: string = '';
  @Input() isOpen: boolean = false;
  @Input() disabled: boolean = false;
  @Input() variant: AccordionVariant = 'default';
  @Input() iconPosition: 'left' | 'right' = 'right';

  @Output() panelToggle = new EventEmitter<boolean>();

  @ContentChild(AccordionHeaderDirective) customHeader: AccordionHeaderDirective;

  toggle(): void {
    if (this.disabled) {
      return;
    }
    this.isOpen = !this.isOpen;
    this.panelToggle.emit(this.isOpen);
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggle();
    }
  }

  getPanelClass(): string {
    const classes = ['accordion-panel', 'accordion-panel--' + this.variant];
    if (this.isOpen) { classes.push('accordion-panel--open'); }
    if (this.disabled) { classes.push('accordion-panel--disabled'); }
    return classes.join(' ');
  }
}
